import { Box, Button, CircularProgress, Grid, Stack, Typography, useTheme } from "@mui/material";
import React, { useRef, useState } from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import ConfirmComponent from "../../components/Confirm";
import DrawerComponent from "../../components/Drawer";
import { SelectCustom, TextAreaCustom } from "../../components/FormElements";
import { CloseLineIcon, DeleteIcon, FileUploadIcon, iconFontSize, PlusIcon } from "../../components/IconComponent";
import AddAttachment from "../../components/AddAttachment";
import AlertComponent from "../../components/Alert";
import { replaceParamTranslation } from "../../utils/util";
import CameraComponent from "../../components/CameraComponent";
import { GetIconColor } from "../../theme/main_style";
import Modal from "../../components/Modal";

export default function AddServiceRequestView(props) {
    const { palette, spacing } = useTheme();
    const { t } = useTranslation();
    const [description, setDescription] = useState(null);
    const [note, setNote] = useState(null);
    const { classifications, classification, addAttachment, setAddAttachment, files, maximumFilesNumber, message } = props;
    let isEnableAction = classification && description ? true : false;
    const [showCamera, setShowCamera] = useState(false);

    const [fromServiceRequestAddAttachment, setFromServiceRequestAddAttachment] = useState(false);

    const onClickAddAttachment = () => {
        setFromServiceRequestAddAttachment(true);
        if (files.length < maximumFilesNumber) {
            setAddAttachment(true);
        } else {
            props.setMessage({show: true, content: (t("error_max_files")), callBackFn: () => props.setMessage({}) });
        }
    }
    return (
        <>
            <DrawerComponent isOpen={props.open} onClose={props.onClose} title={t('new_service_request')} showProcessing={props.showProcessing} message={props.message}  headerPosition='relative' width='100%'>
                <Typography my={1} variant="subtitle2">{t('new_service_request_intro')}</Typography>
                {props.showLoading && <center><CircularProgress size={'1.25rem'}/></center>}
                <Form
                    onSubmit={props.onSubmit}
                    render={({ handleSubmit }) => (
                        <Grid item xs={12}>
                            <Grid item xs={12} marginY={2} id="classification">
                                <Field
                                    name="classification"
                                    label={t('classification')}
                                    component={SelectCustom}
                                    placeholder={t(' ')}
                                    keyName={'id'}
                                    keyLabel={'classification'}
                                    isEdit={true}
                                    isValid={true}
                                    selectData={classifications}
                                    defaultValueSelect={classification && classification.id ? classification.id : null}
                                    onSelectedChange={(event) => props.setClassification(event.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} marginY={2}>
                                <Field
                                    name="description"
                                    label={t('description')}
                                    component={TextAreaCustom}
                                    isEdit={true}
                                    isValid={true}
                                    onCustomChange={(value) => setDescription(value)}
                                />
                            </Grid>
                            <Grid item xs={12} marginY={2}>
                                <Field
                                    name="note"
                                    label={t('service_request_notes')}
                                    component={TextAreaCustom}
                                    isEdit={true}
                                    onCustomChange={(value) => setNote(value)}
                                />
                            </Grid>
                            <Grid>
                                <Button
                                    fullWidth   
                                    disabled={files.length >= maximumFilesNumber}
                                    variant="outlined"
                                    sx={{
                                        borderRadius:'8px',
                                        borderColor: palette.border.main,
                                        '&:hover': {
                                            backgroundColor: palette.background.main,
                                            color: palette.primary.main,
                                        },
                                    }}
                                    onClick={() => onClickAddAttachment() }
                                >
                                    
                                    <Stack flex={1} alignItems={'center'} direction={'row'}>
                                        <Typography sx={{opacity : files.length >= maximumFilesNumber ? 0.7 : 1}}>{t('add_attachment')}</Typography>
                                    </Stack>
                                    <Stack direction={'row'} flex={0.2} justifyContent='flex-end'>
                                        <PlusIcon color={files.length >= maximumFilesNumber ? GetIconColor().default : GetIconColor().primary}/>
                                    </Stack>
                                </Button>
                            </Grid>
                            <Grid item container xs={12} marginTop={2}>
                                {files && files.length > 0 && files.map((f, i) => {
                                    return (
                                        <Box key={i} display="flex" alignItems="center" mb={1} p={1} borderRadius={1} width="100%">
                                            {f.type && f.type.includes('image') && <img alt={f.name} src={f.uri} width={40} height={40} style={{ borderRadius: 4, objectFit: 'cover', marginRight: 8 }} />}
                                            <Box flex={1} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">{f.name}</Box>
                                            <Box onClick={() => props.onDeleteFile(f)} sx={{ cursor: 'pointer' }}>
                                                <CloseLineIcon size={iconFontSize.xs}/>
                                            </Box>
                                        </Box>
                                    )
                                })}
                            </Grid>
                            <Grid item xs={12} mt={2}>
                                {files && files.length > 0 && <Typography variant="subtitle2">{replaceParamTranslation(t('attachments_uploaded'), [files.length, maximumFilesNumber])}</Typography>}
                            </Grid>
                            <Grid item xs={12} mt={2}>
                                <Button fullWidth color="primary" variant="contained" disabled={!isEnableAction} id="addServiceRequest/Submit" onClick={handleSubmit}>{t('btn_submit')}</Button>
                            </Grid>
                        </Grid>
                    )}
                />
                {addAttachment && files.length < maximumFilesNumber ? 
                    <Modal enableCloseButton isOpen={addAttachment} onClose={() => setAddAttachment(false)} title={t("upload_files")} maxWidth={'sm'}>
                        <AddAttachment chooseFromGaleryTitle={t('from_gallery')} onUploadFile={props.uploadFiles} setShowCamera={setShowCamera} isMultipleFile={true} files={files} maximumFilesNumber={maximumFilesNumber} setMessage={props.setMessage} fromServiceRequestAddAttachment={fromServiceRequestAddAttachment} icon={FileUploadIcon} removeFile={props.removeFile} takeAPhoto={true}/>                    
                        <Box display="flex" justifyContent="flex-end" gap={2}>
                            <Button fullWidth id="confirm/btnOK" variant="contained" onClick={() => props.onSaveFilesState()}>{'OK'}</Button>
                            <Button fullWidth id="confirm/btnCancel" variant="outlined" onClick={() => setAddAttachment(false)}>{'Cancel'}</Button>
                        </Box>
                    </Modal>
                : <>
                    {files.length >= maximumFilesNumber && message && message.show && <AlertComponent
                        isOpen={message.show}
                        message={message.content}
                        otherMessage={message.otherMessage ? message.otherMessage : null}
                        onClose={message.callBackFn}
                    />}
                </>
                }

                {showCamera && <CameraComponent/>}
            </DrawerComponent>
        </>
    )
}